// extracted by mini-css-extract-plugin
export default {"font-serif":"font-serif_INiXg","searchBar":"searchBar_FTBhi"};